// src/components/private/highgarden/groceryLists/PurchasedItems.js
// Component to show the list of purchased items

import { useMemo, useState } from 'react';
import { OverlayTrigger, Tooltip, Badge, ListGroup, Row, Container } from 'react-bootstrap';
import PurchaseDetailsModal from './PurchaseDetailsModal';

const PurchasedItems = ({ purchasedItems, onUndoPurchase, refreshList, getItemMeasure }) => {
    const [showDetailsModal, setShowDetailsModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);

    // useMemo to sort items by 'purchased_on' in descending order only when items changes
    const sortedItems = useMemo(() => {
        return [...purchasedItems].sort((a, b) => new Date(b.purchased_on) - new Date(a.purchased_on));
    }, [purchasedItems]);

    // Render the component
    return (
        <Container>
            {sortedItems.length > 0 ? (
                <Row>
                    <ListGroup variant="flush">
                        {sortedItems.map((item) => (
                            <ListGroup.Item
                                key={item.id}
                                style={{ cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                                onClick={() => {
                                    setSelectedItem(item);
                                    setShowDetailsModal(true);
                                }}
                            >
                                <div className="d-flex justify-content-between w-100">
                                    <div>
                                        <Badge style={{ marginRight: '10px' }} bg='success'>{item.quantity}x</Badge>
                                        <strong style={{ fontSize: '14px' }}>{item.name}</strong>
                                    </div>
                                    <div className="d-flex ml-auto">
                                        <div style={{ marginRight: '7px' }}>
                                            {item.product &&
                                                <Badge style={{ marginRight: '10px' }}>{item.linked_product.product_brand.name} - {item.linked_product.name} - {getItemMeasure(item)}</Badge>
                                            }
                                        </div>
                                        <div>
                                            <OverlayTrigger
                                                placement="top"
                                                overlay={<Tooltip id="tooltip-top-trash">Undo purchase</Tooltip>}
                                            >
                                                <i className="bi bi-arrow-counterclockwise"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={(e) => {
                                                        e.stopPropagation(); // Prevents the ListGroup.Item onClick from firing
                                                        onUndoPurchase(item.id);
                                                    }}>
                                                </i>
                                            </OverlayTrigger>
                                        </div>
                                    </div>

                                </div>

                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                </Row>
            ) : (
                <div>There are no purchased items in this list.</div>
            )}
            <PurchaseDetailsModal
                show={showDetailsModal}
                onHide={() => setShowDetailsModal(false)}
                item={selectedItem}
                refreshList={refreshList}
            />
        </Container>
    );
};

export default PurchasedItems;
